import { FC } from "react";

import styles from './styles.module.scss'
import { IconInstagram, IconPresent } from "shared/assets/icons";
import { LEGAL_LINKS } from "shared/config/legal-links";

const IT_CODE_0201_TITLE =
    '02.01 — Реализация программ для ЭВМ, в том числе путем предоставления удаленного доступа посредством информационно-телекоммуникационных сетей, включая информационно-телекоммуникационную сеть «Интернет»';

export const Footer: FC = () => {
    return (
        <div className={styles.footer} id="contacts">
            <div className={styles.__in}>

                <div className={styles.header}>
                    <div className={styles.brand}>
                        <h3 className={styles.brand_title}>Ансариум</h3>
                        <p className={styles.brand_subtitle}>
                            Разработка современных цифровых решений и IT-образование
                        </p>
                    </div>
                </div>

                <div className={styles.main}>

                    <div className={styles.section}>
                        <div className={styles.sub_title}>Контакты</div>
                        <div className={styles.list}>
                            <div className={styles.li}>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M14 11.5V13.5C14 13.7652 13.8946 14.0196 13.7071 14.2071C13.5196 14.3946 13.2652 14.5 13 14.5H3C2.73478 14.5 2.48043 14.3946 2.29289 14.2071C2.10536 14.0196 2 13.7652 2 13.5V11.5M11 5.5L8 2.5M8 2.5L5 5.5M8 2.5V10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                <a href="mailto:ansar.aicompany@gmail.com" style={{color: 'inherit', textDecoration: 'none'}}>
                                    <span>ansar.aicompany@gmail.com</span>
                                </a>
                            </div>
                            <div className={styles.li}>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M14.5 11.28V13.28C14.5009 13.4657 14.4645 13.6494 14.3929 13.8195C14.3214 13.9897 14.2164 14.1426 14.0842 14.2689C13.9519 14.3952 13.7954 14.4922 13.6244 14.5538C13.4535 14.6154 13.2718 14.6403 13.09 14.627C11.0427 14.4057 9.07652 13.6564 7.35997 12.437C5.77297 11.3258 4.44587 9.85051 3.48247 8.12602C2.24997 6.29502 1.49997 4.19302 1.27997 1.99702C1.26672 1.80452 1.29157 1.61152 1.35317 1.42952C1.41477 1.24752 1.51177 1.07977 1.63842 0.93652C1.76507 0.79327 1.91847 0.67752 2.08997 0.59652C2.26147 0.51552 2.44697 0.47102 2.63497 0.46202H4.63497C4.96447 0.45877 5.28472 0.57152 5.54047 0.78252C5.79622 0.99352 5.97222 1.28952 6.03497 1.61702C6.15372 2.27202 6.34872 2.91152 6.61647 3.52302C6.70722 3.72802 6.74147 3.95252 6.71622 4.17402C6.69097 4.39552 6.60697 4.60702 6.47397 4.78602L5.61247 5.73602C6.60997 7.47352 8.06697 9.05302 9.64747 10.125L10.509 9.17502C10.676 9.03102 10.874 8.93902 11.082 8.91152C11.29 8.88402 11.5 8.92202 11.691 9.01952C12.2625 9.31152 12.8605 9.52102 13.476 9.64602C13.7985 9.70902 14.091 9.88527 14.302 10.1435C14.513 10.4018 14.627 10.7248 14.625 11.057L14.5 11.28Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                <a href="tel:+79953334456" style={{color: 'inherit', textDecoration: 'none'}}>
                                    <span> +7 995 333 4456</span>
                                </a>
                            </div>
                            <div className={styles.li}>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M13 6.66667C13 11 8 14.3333 8 14.3333C8 14.3333 3 11 3 6.66667C3 5.34058 3.52678 4.06881 4.46447 3.13113C5.40215 2.19345 6.67392 1.66667 8 1.66667C9.32608 1.66667 10.5979 2.19345 11.5355 3.13113C12.4732 4.06881 13 5.34058 13 6.66667Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M8 8.66667C9.10457 8.66667 10 7.77124 10 6.66667C10 5.5621 9.10457 4.66667 8 4.66667C6.89543 4.66667 6 5.5621 6 6.66667C6 7.77124 6.89543 8.66667 8 8.66667Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                <a href="https://yandex.ru/maps/?text=Грозный%20ул.%20Сайханова%2029А" target="_blank" rel="noopener noreferrer" style={{color: 'inherit', textDecoration: 'none'}}>
                                    <span>г.Грозный ул. Сайханова 29А</span>
                                    {/* <span>С ЦЕНТОРА-ЮРТ, УЛ ЭНГЕЛЬСА, ДВЛД. 35/22</span> */}
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className={styles.section}>
                        <div className={styles.sub_title}>Наши услуги</div>
                        <div className={styles.list}>
                            <a href="#services"><div className={styles.li}><span>Веб-разработка</span></div></a>
                            <a href="#services"><div className={styles.li}><span>Мобильные приложения</span></div></a>
                            <a href="#courses"><div className={styles.li}><span>IT-обучение</span></div></a>
                            <a href="#projects"><div className={styles.li}><span>Наши проекты</span></div></a>
                        </div>
                    </div>

                <div className={styles.section}>
                    <div className={styles.sub_title}>Сообщество и соцсети</div>
                    <div className={styles.list}>
                        {/* <a href="https://t.me/ansar_live" target="_blank" rel="noopener noreferrer">
                            <div className={styles.li}><span>Ansar Live</span></div>
                        </a> */}
                        <a href="https://t.me/ansarium" target="_blank" rel="noopener noreferrer">
                            <div className={styles.li}><span>Ansarium</span></div>
                        </a>
                        {/* <a href="https://t.me/it_ansar_company" target="_blank" rel="noopener noreferrer">
                            <div className={styles.li}><span>Ansar Company</span></div>
                        </a> */}
                        <a href="https://instagram.com/ansar_itcompany" target="_blank" rel="noopener noreferrer">
                            <div className={`${styles.li} ${styles.social}`}>
                                <IconInstagram width={20} height={20} />
                                <span>@ansar_itcompany</span>
                            </div>
                        </a>
                        <a href="https://ansarium.ru" target="_blank" rel="noopener noreferrer">
                            <div className={`${styles.li} ${styles.social}`}>
                                <IconPresent width={20} height={20} />
                                <span>Платформа Ансариум</span>
                            </div>
                        </a>
                    </div>
                </div>

                <div className={styles.section}>
                    <div className={styles.sub_title}>Реквизиты</div>
                    <div className={styles.list}>
                        <div className={styles.requisite}>
                            {/* <span className={styles.requisite_label}>Организация:</span> */}
                            <span className={styles.requisite_value}>Общество с ограниченной ответственностью «Ансариум»</span>
                        </div>
                        <div className={styles.requisite}>
                            <span className={styles.requisite_label}>ИНН:</span>
                            <span className={styles.requisite_value}>2004013205</span>
                        </div>
                        <div className={styles.requisite}>
                            <span className={styles.requisite_label}>ОКВЭД:</span>
                            <span className={styles.requisite_value}>62.01</span>
                        </div>
                        <div className={styles.requisite}>
                            <span className={styles.requisite_label}>Код ИТ:</span>
                            <span className={styles.requisite_value}>01.01</span>
                        </div>
                        <div className={styles.requisite}>
                            <span className={styles.requisite_label}>Код ИТ:</span>
                            <span className={styles.requisite_value}>
                                <abbr className={styles.itCodeHint} title={IT_CODE_0201_TITLE}>
                                    02.01
                                </abbr>
                            </span>
                        </div>
                        <div className={styles.requisite}>
                            <span className={styles.requisite_label}>ОГРН:</span>
                            <span className={styles.requisite_value}>1252000009359</span>
                        </div>
                    </div>
                </div>

                <div className={styles.section}>
                    <div className={styles.sub_title}>Аккредитация</div>
                    <div className={styles.list}>
                        <div className={styles.requisite}>
                            
                            <span className={styles.requisite_value}>Государственная аккредитация Минцифры РФ</span>
                        </div>
                        <div className={styles.requisite}>
                            <span className={styles.requisite_label}>Номер решения:</span>
                            <span className={styles.requisite_value}>АО-20251112-33989584805-3</span>
                        </div>
                        <div className={styles.requisite}>
                            <span className={styles.requisite_label}>Дата аккредитации:</span>
                            <span className={styles.requisite_value}>13.11.2025</span>
                        </div>
                        <div className={styles.requisite}>
                            <span className={styles.requisite_label}>Номер в реестре:</span>
                            <span className={styles.requisite_value}>76889</span>
                        </div>
                        <div className={styles.requisite}>
                            <span className={styles.requisite_label}>Вид деятельности:</span>
                            <span className={styles.requisite_value}>62.01 Разработка компьютерного программного обеспечения</span>
                        </div>
                    </div>
                </div>

                    <nav className={styles.section} aria-label="Юридические документы">
                        <div className={styles.sub_title}>Документы</div>
                        <div className={styles.list}>
                            <a href={LEGAL_LINKS.privacy} target="_blank" rel="noopener noreferrer">
                                <div className={styles.li}><span>Политика обработки персональных данных</span></div>
                            </a>
                            <a href={LEGAL_LINKS.terms} target="_blank" rel="noopener noreferrer">
                                <div className={styles.li}><span>Пользовательское соглашение</span></div>
                            </a>
                        </div>
                    </nav>

                </div>

                <div className={styles.bottom}>
                    <div className={styles.copyright}>
                        <span className={styles.brand_name}>Ансариум</span>
                        <span className={styles.year}>© 2025</span>
                    </div>
                    <div className={styles.tagline}>
                        Будущее накодится здесь
                    </div>
                </div>

            </div>
        </div>
    )
}